import { AfterContentInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../../../shared/service/rest.service';
import { MyProfileModel, NewRegistrationModel, RegisterAccountModel } from '../../../shared/model/UserProfile';
import { AuthServiceCustom, EmailRegex } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { AbstractDataProvider } from '../../AbstractDataProvider';
import { SecurityQuestionAnswer } from '../../security/QueryStringParam';
import { DictionaryPipe } from '../../../shared/pipes/dictionary.pipe';
import { StepperComponent } from '../stepper/stepper.component';
import { finalize } from 'rxjs/operators';
import { VerifyAccountByPinModel } from '../../../shared/model/interfaces';
import { HttpClient } from '@angular/common/http';
import {getErrorMessageText} from '../../helper';

const PasswordRegex = new RegExp('^(?=\\D*\\d)(?=.*?[a-zA-Z]).*[\\W_].*$');

@Component({
  selector: 'app-rep-registration',
  templateUrl: './rep-registration.component.html',
  styleUrls: ['./rep-registration.component.scss'],
  providers: [DictionaryPipe]
})
export class RepRegistrationComponent implements OnInit, AfterContentInit {

  @ViewChild('stepper') stepper: StepperComponent;

  userProfile: NewRegistrationModel = new NewRegistrationModel();

  display = false;
  alertMessage: string;
  clientCode: string;
  isUserIdValid = false;
  contactPhone: string;

  steps: {title: string; id: string}[] = [];
  activeStep = 0;

  securityQuestionAnswer: SecurityQuestionAnswer = new SecurityQuestionAnswer();
  questionList = [{SecQuestionText: 'dd', SecQuestionCode: 'CD1'}];
  isRegistrationCompleted = false;
  logoImageUrl: string;
  bgImageUrl: string;
  showPin: boolean;
  showPassword: boolean;
  showPasswordConfirmation: boolean;
  private saveTimeout: number;

  @HostListener('window:keyup', ['$event'])
  onEnterPress(event: KeyboardEvent): void {
    if (event.keyCode !== 13) { // enter
      return;
    }
    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }
    if (this.display) {
      return;
    }
    if (this.activeStep !== this.steps.length - 1) {
      this.continue();
    } else {
      this.tryScheduleSave();
    }
  }

  constructor(
    public rest: RestService,
    private authService: AuthServiceCustom,
    private abstractDataProvider: AbstractDataProvider,
    private dictionaryPipe: DictionaryPipe,
    private http: HttpClient,
    private ngxService: NgxUiLoaderService) {

    this.steps = [
      {title: 'REGISTER_NEW_ACCOUNT', id: 'REGISTER_NEW_ACCOUNT'},
      // {title: 'CHALLENGE_QUESTIONS', id: 'CHALLENGE_QUESTIONS'},
      {title: 'USER_PROFILE', id: 'USER_PROFILE'},
    ];
  }

  ngOnInit() {
    this.clientCode = this.authService.clientCode;
    this.contactPhone = this.authService.wpContactPhone;
    this.getListOfSecurityQuestions();
    this.bgImageUrl = this.authService.clientBackgroundImageUrl;

    this.authService.clientConfigLoaded.subscribe(() => {
      this.contactPhone = this.authService.wpContactPhone;
    });
  }

  ngAfterContentInit() {
    this.clientCode = this.authService.clientCode;
    this.logoImageUrl = this.authService.clientLogoUrl;
    this.authService.accessTokenRemovedSubj.next(true);
  }

  getListOfSecurityQuestions(): void {
    const url = 'api/Configuration/GetSecurityQuestionList';
    this.abstractDataProvider.getData(url).subscribe(
      (posts) => {
        this.questionList = posts.SecurityQuestions;
      },
      (error) => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

  validateUserName(): void {
    if (!this.userProfile.UserId || !this.userProfile.AccountNumber) {
      return;
    }

    this.userProfile.UserId = this.userProfile.UserId.trim();
    const saveAfterValidation = !!this.saveTimeout;
    clearTimeout(this.saveTimeout);
    this.saveTimeout = null;
    this.ngxService.start();
    const dto = {
      RecordType: 'R',
      UserId: this.userProfile.UserId,
      AccountNumber: this.userProfile.AccountNumber && parseInt(this.userProfile.AccountNumber, 10),
      Pin: this.userProfile.PIN,
      TaxId: null
    };
    this.abstractDataProvider.postData(dto, 'api/Accounts/VerifyUserIdAvailable').pipe(finalize(() => this.ngxService.stop())).subscribe((data: {Available: boolean}) => {
      if (!data.Available) {
        this.display = true;
        this.alertMessage = 'This Username is already taken.';
        this.isUserIdValid = false;
      } else if (saveAfterValidation) {
        this.isUserIdValid = true;
        this.save();
      } else {
        this.isUserIdValid = true;
      }
    }, error => {
        this.isUserIdValid = false;
      this.display = true;
      this.alertMessage = getErrorMessageText(error);
    });
  }

  save(): void {

    const errors = [];
    if (!this.userProfile.AccountNumber) {
      errors.push(this.dictionaryPipe.transform('ENTER_REP_ID'));
    }

    if (this.userProfile.AccountNumber && !parseInt(this.userProfile.AccountNumber, 10)) {
      errors.push(this.dictionaryPipe.transform('ENTER_REP_ID'));
    }

    // if (!this.userProfile.UserId) {
    //   errors.push('Username is required');
    // }

    // if (this.userProfile.UserId && !this.isUserIdValid) {
    //   errors.push('Username must be unique');
    // }

    if (!this.userProfile.EmailAddress) {
      errors.push('Email Address is required');
    }

    if (!this.userProfile.ConfirmEmailAddress) {
      errors.push('Confirm Email Address is required');
    }

    if (this.userProfile.ConfirmEmailAddress && this.userProfile.EmailAddress && this.userProfile.ConfirmEmailAddress !== this.userProfile.EmailAddress) {
      errors.push('Confirm Email Address does not match');
    }

    if (this.userProfile.EmailAddress && !this.userProfile.EmailAddress.match(EmailRegex)) {
      errors.push('Invalid Email Address');
    }

    this.userProfile.UserId = this.userProfile.EmailAddress;

    // if (!this.userProfile.Password) {
    //   errors.push('Password is required');
    // }

    if (!this.userProfile.TermsAndConditionAgreed) {
      errors.push('Please accept Terms and Condition');
    }

    // if (this.userProfile.Password) {
    //   const minLength = 8; // TODO: move outside the method
    //   if (this.userProfile.Password.length < minLength) {
    //     errors.push(this.dictionaryPipe.transform('AT_LEAST_CHARACTERS', minLength));
    //   }
    //   if (!PasswordRegex.test(this.userProfile.Password)) {
    //     errors.push(this.dictionaryPipe.transform('ALPHA_NUMERIC_SPECIAL'));
    //   }
    // }

    // const validatedObj = this.authService.validateSecurityQuestionAnswer(this.securityQuestionAnswer);
    // if (!validatedObj.isValid) {
    //   errors.push(validatedObj.alertmessage);
    // }

    // if (!this.userProfile.ConfirmPassword) {
    //   errors.push('Confirm Password is required');
    // }

    // if (this.userProfile.ConfirmPassword && this.userProfile.Password && this.userProfile.ConfirmPassword !== this.userProfile.Password) {
    //   errors.push('Confirm Password does not match');
    // }

    if (errors.length) {
      this.display = true;
      this.alertMessage = 'Please fix errors: <br>' + errors.join(', <br>');
      return;
    }


    const dto = {
      RecordType: 'R',
      AccountNumber: parseInt(this.userProfile.AccountNumber, 10),
      Pin: this.userProfile.PIN,
      TaxId: null,
      ZipCode: null,

      UserName: this.userProfile.UserId.toUpperCase(),
      Password: this.userProfile.Password,
      EmailAddress: this.userProfile.EmailAddress,

      // SecQuestionText1: this.questionList.find(item => item.SecQuestionCode === this.securityQuestionAnswer.SecQuestionCode1).SecQuestionText,
      // SecQuestionCode1: this.securityQuestionAnswer.SecQuestionCode1,
      // SecAnswerText1: this.securityQuestionAnswer.SecAnswerText1,
      // SecQuestionText2: this.questionList.find(item => item.SecQuestionCode === this.securityQuestionAnswer.SecQuestionCode2).SecQuestionText,
      // SecQuestionCode2: this.securityQuestionAnswer.SecQuestionCode2,
      // SecAnswerText2: this.securityQuestionAnswer.SecAnswerText2,
      // SecQuestionText3: this.questionList.find(item => item.SecQuestionCode === this.securityQuestionAnswer.SecQuestionCode3).SecQuestionText,
      // SecQuestionCode3: this.securityQuestionAnswer.SecQuestionCode3,
      // SecAnswerText3: this.securityQuestionAnswer.SecAnswerText3,

      SendEmails: this.userProfile.ElectronicMailAgreed ? 'Y' : 'N'
    } as RegisterAccountModel;
    this.ngxService.start();

    this.abstractDataProvider.postData(dto, 'api/Accounts/RegisterAccount').pipe(finalize(() => this.ngxService.stop())).subscribe(() => {
      this.isRegistrationCompleted = true;
    }, error => {
      this.display = true;
      this.alertMessage =  getErrorMessageText(error, error.error);
    });
  }

  showTerms(): void {
    const url = `assets/TERMS.html`;
    this.http.get(url, {responseType: 'text'}).subscribe(data => {
      this.display = true;
      this.alertMessage = data;
    });
  }

  preventPaste(e: any): void {
    e.preventDefault();
  }

  continue(): void {
    if (this.steps[this.activeStep].id === 'REGISTER_NEW_ACCOUNT') {
      this.validatePinAndAccountNum();
      return;
    }
    if (this.steps[this.activeStep].id === 'CHALLENGE_QUESTIONS') {

      const validatedObj = this.authService.validateSecurityQuestionAnswer(this.securityQuestionAnswer);
      if (!validatedObj.isValid) {
        this.display = true;
        this.alertMessage = validatedObj.alertmessage;
        return;
      }
      this.stepper.changeStep(this.activeStep + 1);

      return;
    }

  }

  submit() {
    if (!this.userProfile.PIN) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_PIN');
      return;
    }
  }

  cancel() {
    this.authService.navigateToLogin();
  }

  onClosePopup() {
    this.display = false;
  }

  navigateToLogin(isDisplayed = false) {
    this.isRegistrationCompleted = isDisplayed;
    this.authService.navigateToLogin();
  }

  tryScheduleSave() {
    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }
    this.saveTimeout = window.setTimeout(() => {
      this.saveTimeout = null;
      this.save();
    });
  }

  private validatePinAndAccountNum(): void {
    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }
    if (!this.userProfile.AccountNumber) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_REP_ID');
      return;
    }

    if (this.userProfile.AccountNumber && !parseInt(this.userProfile.AccountNumber, 10)) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('REP_ID_NUMERIC');
      return;
    }


    if (!this.userProfile.PIN) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_PIN');
      return;
    }
      this.ngxService.start();

      const dto = {
        AccountNumber: parseInt(this.userProfile.AccountNumber, 10),
        PIN: this.userProfile.PIN.toUpperCase(),
        RecordType: 'R'
      } as VerifyAccountByPinModel;

      this.abstractDataProvider.postData(dto, 'api/Accounts/VerifyAccountByPin')
        .pipe(finalize(() => this.ngxService.stop()))
        .subscribe((userProfile: {Data: MyProfileModel}) => {
          const index = this.steps.findIndex(s => s.id === 'ACCOUNT_VERIFICATION');

          if (!userProfile) {
            this.display = true;
            this.alertMessage = 'PIN or Advisor ID is invalid.'; // TODO: move to dictionary
          } else {
            this.stepper.changeStep(this.activeStep + 1);
            this.fillInputs(userProfile);
          }
        }, error => {
          if (error.status === 403) {
            this.display = true;
            this.alertMessage =  getErrorMessageText(error, 'User already registered.');

          } else {
            this.display = true;
            this.alertMessage =  getErrorMessageText(error, 'PIN or Advisor ID is invalid.');
          }
        });
  }

  private fillInputs(userProfile: {Data: MyProfileModel}): void {
    const sec = userProfile.Data.SecurityQuestions;
    this.securityQuestionAnswer.SecQuestionCode1 = sec.SecQuestionCode1;
    this.securityQuestionAnswer.SecQuestionCode2 = sec.SecQuestionCode2;
    this.securityQuestionAnswer.SecQuestionCode3 = sec.SecQuestionCode3;
    this.securityQuestionAnswer.SecAnswerText1 = sec.SecAnswerText1;
    this.securityQuestionAnswer.SecAnswerText2 = sec.SecAnswerText2;
    this.securityQuestionAnswer.SecAnswerText3 = sec.SecAnswerText3;

    this.userProfile.UserId = userProfile.Data.EmailAddress;
    this.userProfile.EmailAddress = userProfile.Data.EmailAddress;
    this.userProfile.ConfirmEmailAddress = userProfile.Data.EmailAddress;
    this.userProfile.ElectronicMailAgreed = Boolean(userProfile.Data.IsElectronicMailSubscribed === 'Y');
  }

  toUpperCaseInput(event: KeyboardEvent) {
    const input = (event.target as HTMLInputElement);
    input.value = input.value && input.value.toString().toUpperCase();
  }
}
